// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-J1":"J1_vanlife-roadtrips-J1__X4b5a"};